<template>
    <div class="rental-create layout-small-form">
        <data-form title="Add Rental"
                   tag="add-rental"
                   save-button-label="Submit"
                   :field-model="rental"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="returnRoute"

                   submit-success-message="Rental added"
                   submit-error-message="Error creating rental"/>

    </div>
</template>

<script>
import Rental from '@/models/Rental'

export default {
    name: 'RentalCreate',
    props: {
        projectId: Number,
    },
    data () {
        return {
            rental: Rental,
            fieldGroups: [
                ['rental_company', 'not_found', 'agreement_number',
                    'name', 'address_1', 'address_2', 'city', 'state', 'zip', 'phone', 'email']
            ],
        }
    },
    computed: {
        returnRoute () {
            return '/project/view/' + this.projectId
        }
    },
    methods: {
        onSubmit (modelInstance) {
            modelInstance['project_id'] = this.projectId
            modelInstance['company_id'] = this.$user.getCompanyId()
            return this.$api.createItem(this, 'rental', modelInstance).then((response) => {
                this.$router.push(this.returnRoute)
                return Promise.resolve()

            }, (error) => {
                this.$toasted.show(error.body.message)
                this.$router.push(this.returnRoute)
                return Promise.reject()
            })
        }
    },
}
</script>

<style scoped>

</style>